import { defineStore } from 'pinia';
import { Request } from '@fibl/oxs-common';
import { EAV } from '@fibl/zdb-common';
import * as SearchRepo from '@/repository/search.js';

export const useRequestManagementStore = defineStore('requestManagement', {
	state: () => ({
		formFields: [] as EAV.Entity<Request.RequestFormField>[],
	}),


	getters: {
		byId() {
			return (id: string): EAV.Entity<Request.RequestFormField> | undefined => {
				//latest rev
				return this.formFields
					.filter((e) => e.id === id)
					.sort((a, b) => b.rev - a.rev)[0];
			};
		},

		byIdRev() {
			return (id: string, rev: number): EAV.Entity<Request.RequestFormField> | undefined => {
				return this.formFields.find((e) => e.id === id && e.rev === rev);
			};
		},

		latestRevs(): EAV.Entity<Request.RequestFormField>[] {
			let ids = new Set();
			return this.formFields
				.slice(0)
				.sort((a, b) => b.rev - a.rev)
				.filter((e) => {
					if (ids.has(e.id)) return false;
					ids.add(e.id);
					return true;
				});
		},
	},

	actions: {
		async loadAll() {
			if (this.formFields.length > 0) return;
			let res = await SearchRepo.findAll<Request.RequestFormField>('requestformfield', undefined, true);
			this.formFields = res;
		},

		async get(id: string, rev: number): Promise<EAV.Entity<Request.RequestFormField>> {
			let existing = id && rev ? this.byIdRev(id, rev) : null;
			if (existing) return existing;
			let entity = await SearchRepo.getEntityByIdRev<Request.RequestFormField>(id, rev);
			this.formFields.push(entity);
			return entity;
		},

		getFromStep(
			fields: { id: string; rev: number }[],
		): Promise<EAV.Entity<Request.RequestFormField>[]> {
			return Promise.all(fields.map((r) => this.get(r.id, r.rev)));
		},

		addToList(entity: EAV.Entity<Request.RequestFormField>) {
			let exists = this.formFields.find((e) => e.id === entity.id && e.rev === entity.rev);
			if (exists) return;
			this.formFields.push(entity);
		},
	},
});
